import * as PIXI from "pixi.js"
import { gameManager } from "./gameManager.js";
import { getCrashBackgroundAsset, path } from "./settings.js";
import { getThemeSlug } from '../../theme/themes'
import smokeAceFly from '../../assets/images/Fly.png'


export var assetsLoaded = false
export var promiseAssets

let activeLoadTheme = null
let loadPromise = null

export function startLoadingAssets(setIsPixiLoading, themeSlug) {
    const resolvedTheme = getThemeSlug(themeSlug)

    if (activeLoadTheme === resolvedTheme && loadPromise) {
        return loadPromise
    }

    activeLoadTheme = resolvedTheme
    assetsLoaded = false
    setIsPixiLoading(true)

    loadPromise = loadAssets(resolvedTheme)
        .then(async function () {
            onAssetsLoaded()
            assetsLoaded = true
            const {
              updateCrashBackground,
              updateCrashRocket,
              updateMultiplierBgBox,
              updateCrashLoadingTheme,
            } = await import('./gameUI.js')
            await updateCrashBackground(resolvedTheme)
            updateCrashRocket()
            updateMultiplierBgBox()
            updateCrashLoadingTheme()
        })
        .then(function () {
            setIsPixiLoading(false)
            console.log("Assets loaded");
        })
        .catch(function (e) {
            console.error(e)
            setIsPixiLoading(false)
        })

    return loadPromise
}

const GAME_ASSETS_BUNDLE = 'GameAssets'

async function loadAssets(themeSlug) {
    const bgAsset = getCrashBackgroundAsset(themeSlug).src;

    if (PIXI.Assets.resolver.hasBundle(GAME_ASSETS_BUNDLE)) {
      await PIXI.Assets.unloadBundle(GAME_ASSETS_BUNDLE).catch(() => {})
    }

    PIXI.Assets.addBundle(GAME_ASSETS_BUNDLE, {
      bold: path.fontPath+'Barlow-Bold.ttf',
      semiBold: path.fontPath+'Barlow-SemiBold.ttf',
      ultraRegular: path.fontPath+'Ultra-Regular.ttf',
      allAssets: path.spriteSheetsPath+'mainAssets.json',
      explosion: path.spriteSheetsPath+'explosion.json',
      Bg: bgAsset,
      clouds: path.spriteSheetsPath+'clouds.json',
      loaderFiller: path.imagePath+'loaderFiller.png',
      loaderBg: path.imagePath+'loaderBg.png',
      smokeAceFly,
      rocketThemeTwo: path.imagePath + 'rocket 1.png'
    });

   promiseAssets = await PIXI.Assets.loadBundle(GAME_ASSETS_BUNDLE);
}

function onAssetsLoaded() {
    gameManager()
}
